export default __webpack_public_path__ + "static/media/Farm-Black.ff99b251.png";